import BaseChangeset from 'common/changesets/base';

export type NewsletterDTO = {
  id?: string;
  email: string;
};

export class NewsletterChangeset extends BaseChangeset<NewsletterDTO> {}
